<style>
  .mat-form-field-flex {
    border: 0px solid #c7c6c6;
    border-radius: 5px;
    height: 52px;
  }

  .mat-form-field-underline {
    display: none !important;
    bottom: -100px !important;
  }

  .download-damage-report {
    background-color: #f4f4f4;
    padding: 8px;
    padding-left: 15px;
    padding-right: 15px;
    border-left: 1px solid #c7c7c7;
    color: black;
    border-radius: 5px;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    height: 52px;
  }
</style>
<button mat-dialog-title mat-mini-fab color="primary" style="margin: 3px;" [mat-dialog-close]><mat-icon>close</mat-icon></button>
<mat-dialog-content>
  <div *ngIf="isTrailerInspectionFlow" style="width: 800px;">
    <h1>Create service requests for selected trailers ({{ rentalObjects.length }})</h1>

    <t4-container title="Selected trailers">
      <mat-form-field style="width:50%;">
        <mat-label>{{ 'Turbo.Service.CreateServiceRequestDialog.lblServicePartner' | translate : 'Service Partner' }}</mat-label>
        <mat-select [(ngModel)]="selectedServicePartnerId" matNativeControl>
          <mat-option *ngFor="let p of servicePartners" [value]="p.Id">{{ p.Name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field style="width:100%">
        <textarea matInput [(ngModel)]="description" placeholder="Short description for all requests" matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="6"></textarea>
      </mat-form-field>

      <t4-data-table #tblInStock [allowFilter]="false" [allowPaging]="false" [allowExcel]="false" [rawData]="rentalObjects" headline="{{'Turbo.Service.CreateServiceRequestDialog..lblserviceguystock' | translate : 'Stock' }}" matSort matSortActive="ConfirmedDt" matSortDirection="desc" [autoGenerateColumns]="false">

        <ng-container matColumnDef="Title">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'Turbo.Service.CreateServiceRequestDialog.Title' |translate : 'Title' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.Title }}<ng-container></ng-container></mat-cell>
        </ng-container>

        <ng-container matColumnDef="RentalLocation.Name">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'Turbo.Service.CreateServiceRequestDialog.RentalLocationName' |translate : 'RentalLocation name' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{ row.RentalLocation.Name }}<ng-container></ng-container></mat-cell>
        </ng-container>

        <ng-container matColumnDef="NextInspectionDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">{{'Turbo.Service.CreateServiceRequestDialog.NextInspectionDate' |translate : 'Next Inspection Date' }}</mat-header-cell>
          <mat-cell *matCellDef="let row" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width:100px;">  {{ row.NextInspectionDate | date:'yyyy-MM-dd' }}<ng-container></ng-container></mat-cell>
        </ng-container>

      </t4-data-table>
    </t4-container>

  </div>

  <div *ngIf="!isTrailerInspectionFlow && !issueTypeSelected" style="width: 800px;">
    <h1>{{ 'Turbo.Service.CreateServiceRequestDialog.headlineSelectType' | translate : 'What type of damage hass occurred?' }}</h1>
    <span class="col-sm-4">
      <button mat-raised-button style="white-space: normal;height: 250px; margin: 10px" (click)="createNote()"><img src="/images/Icons/Defect.png" style="width: 75px; height: 75px;" /><h2>{{ 'Turbo.core.dialogs.CreateServiceRequestDialog.lblMinorDefect' | translate : 'Minor defect' }}</h2><p style="line-height: normal; height: 70px">{{ 'Turbo.core.dialogs.CreateServiceRequestDialog.txtMinorDefect' | translate : 'A lesser damage that should be noted but not fixed. For example scratches and bumps.' }}</p></button>
    </span>
    <span class="col-sm-4">
      <button mat-raised-button style="white-space: normal;height: 250px; margin: 10px;-webkit-box-shadow: 0px 0px 10px 0px #ff5f00;-moz-box-shadow: 0px 0px 10px 0px #ff5f00; box-shadow: 0px 0px 10px 0px #ff5f00;" (click)="issueTypeSelected=true; setIssueType(0)"><img src="/images/Icons/Issue.png" style="width: 75px; height: 75px;" /><h2>{{ 'Turbo.core.dialogs.CreateServiceRequestDialog.lblIssue' | translate : 'Damage' }}</h2><p style="line-height: normal; height: 70px">{{ 'Turbo.core.dialogs.CreateServiceRequestDialog.txtIssue' | translate : 'A damage that have to be fixed. For example support wheel, flat tire or crash.' }}</p></button>
    </span>
    <span class="col-sm-4">
      <button mat-raised-button style="white-space: normal;height: 250px; margin: 10px" (click)="issueTypeSelected=true; setIssueType(1)"><img src="/images/Icons/Theft.png" style="width: 75px; height: 75px;" /><h2>{{ 'Turbo.Service.CreateServiceRequestDialog.lblTheft' | translate : 'Theft' }}</h2><p style="line-height: normal; height: 70px">{{ 'Turbo.core.dialogs.CreateServiceRequestDialog.TheftText' | translate : 'The trailer has been stolen from the location or during rent.' }}</p></button>
    </span>
  </div>

  <div *ngIf="!isTrailerInspectionFlow && issueTypeSelected">
    <h1>
      <span>{{ 'Turbo.Service.CreateServiceRequestDialog.DamageHeadline' | translate : 'Create damage report' }}</span>
      - <t4-object-link objectId="{{rentalObject?.Id}}">{{ rentalObject?.Title }}</t4-object-link>
    </h1>
    <div style="width: 600px;">
      <t4-container title="{{ 'Turbo.Service.CreateServiceRequestDialog.lblInfo' | translate : 'Information' }}" [isInvalid]="errDescription">
        <mat-form-field style="width: 100%">
          <textarea matInput [(ngModel)]="description" placeholder="{{ 'Turbo.Service.CreateServiceRequestDialog.lblDescriptionIncident' | translate : 'Description of the incident' }}" matTextareaAutosize matAutosizeMinRows="6" matAutosizeMaxRows="6"></textarea>
        </mat-form-field>
        <div class="errorMessage">{{ 'Turbo.Service.CreateServiceRequestDialog.errInvalidDescription' | translate : 'Please make a clear description of the damage' }}</div>
      </t4-container>

      <t4-container title="{{ 'Turbo.Service.CreateServiceRequestDialog.lblInsurance' | translate : 'Försäkringsärende (Även stöld)' }}" *ngIf="!settings.isInsuranceCase">
        <div class="row text-center">
          <div class="col-12">
            <button mat-flat-button color="primary" style="margin: 50px;" (click)="reportToInsuranceCompany()" *ngIf="!rentalObject.IsManual">
              <mat-icon>wysiwyg</mat-icon>
              {{ 'Turbo.Service.CreateServiceRequestDialog.ReportToInsurance' | translate : 'Report to insurance company' }}
            </button>
            <span *ngIf="rentalObject.IsManual">{{ 'Turbo.Service.CreateServiceRequestDialog.InsuranceNotAvailable' | translate : 'Insurance is not available for this object' }}</span>
          </div>
        </div>
      </t4-container>

      <t4-container title="Typ av incident" *ngIf="settings.isInsuranceCase">
        <div class="row text-center">
          <div class="col-12">
            <mat-form-field style="width: 100%; margin-top: 0px">
              <mat-label>{{ 'Turbo.Service.CreateServiceRequestDialog.Incident' | translate : 'Incident' }}</mat-label>
              <mat-select [(ngModel)]="issueType" matNativeControl required>
                <mat-option value="0">{{ 'Turbo.Service.CreateServiceRequestDialog.DamageDuringRent' | translate : 'Skada (under uthyrning)' }}</mat-option>
                <mat-option value="1">{{ 'Turbo.Service.CreateServiceRequestDialog.DamageAtLocation' | translate : 'Skada (på station)' }}</mat-option>
                <mat-option value="2">{{ 'Turbo.Service.CreateServiceRequestDialog.TheftNotReturnd' | translate : 'Stöld (under uthyrning)' }}</mat-option>
                <mat-option value="3">{{ 'Turbo.Service.CreateServiceRequestDialog.TheftFromRenter' | translate : 'Stöld (från station)' }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field style="margin-top: 10px; width: 100%">
              <input matInput [formControl]="damgeDate" placeholder="{{ 'Turbo.Service.CreateServiceRequestDialog.DamageTheftDate' | translate : 'Damage/theft date' }}" [matDatepicker]="myDatepicker" required />
              <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
              <mat-datepicker #myDatepicker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-12" *ngIf="settings.isInsuranceCase && +this.issueType > 2" style="text-align: left;">
            <mat-checkbox [(ngModel)]="lockConfirmed">{{ 'Turbo.Service.CreateServiceRequestDialog.chkConfirmLocked' | translate : 'The trailer was locked with an approved lock when the incident occurred.' }}</mat-checkbox>
          </div>
        </div>
      </t4-container>

      <t4-container [isInvalid]="errNoDamage" *ngIf="settings.isInsuranceCase && +this.issueType <= 1" title="{{ 'Turbo.Service.CreateServiceRequestDialog.lblDamageSelect' | translate : 'Select damages' }}">
        <mat-form-field>
          <mat-label>{{ 'Turbo.Service.CreateServiceRequestDialog.lblDamageSelect' | translate : 'Select damages' }}</mat-label>
          <mat-select value="selectedDamage" [(ngModel)]="selectedDamage" multiple ngDefaultControl (selectionChange)="setDamages()">
            <mat-option value="lock">{{ 'Turbo.Service.CreateServiceRequestDialog.chkLock' | translate : 'Lock' }}</mat-option>
            <mat-option value="hitch">{{ 'Turbo.Service.CreateServiceRequestDialog.chkHitch' | translate : 'Hitch' }}</mat-option>
            <mat-option value="reflex">{{ 'Turbo.Service.CreateServiceRequestDialog.chkReflex' | translate : 'Reflex' }}</mat-option>
            <mat-option value="wire">{{ 'Turbo.Service.CreateServiceRequestDialog.chkWire' | translate : 'Catastrophe wire' }}</mat-option>
            <mat-option value="lamp">{{ 'Turbo.Service.CreateServiceRequestDialog.chkLamp' | translate : 'Lamp' }}</mat-option>
            <mat-option value="supportWheel">{{ 'Turbo.Service.CreateServiceRequestDialog.chkSupportWheel' | translate : 'Support wheel' }}</mat-option>
            <mat-option value="chassi">{{ 'Turbo.Service.CreateServiceRequestDialog.chkChassi' | translate : 'Chassi' }}</mat-option>
            <mat-option value="tyre">{{ 'Turbo.Service.CreateServiceRequestDialog.chkWheel' | translate : 'Tyre' }}</mat-option>
            <mat-option value="fender">{{ 'Turbo.Service.CreateServiceRequestDialog.chkFender' | translate : 'Fender' }}</mat-option>
            <mat-option value="mudFlap">{{ 'Turbo.Service.CreateServiceRequestDialog.chkMudFlap' | translate : 'Mud flap' }}</mat-option>
            <mat-option value="other">{{ 'Turbo.Service.CreateServiceRequestDialog.chkOther' | translate : 'Other' }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="errorMessage">
          <span *ngIf="errNoDamage">{{ 'Turbo.Service.CreateServiceRequestDialog.errNoDamage' | translate : 'Please specify what is damaged' }}</span>
        </div>
      </t4-container>

      <t4-container [isInvalid]="errNoRecordNumber" title="{{ 'turbo.core.CreateServiceRequestDialog.txtRecordNumber' | translate : 'Record number'}}" *ngIf="settings.isInsuranceCase && +this.issueType > 1">
        <div class="row text-center">
          <div class="col-12">
            <mat-form-field>
              <input matInput placeholder="{{ 'turbo.core.CreateServiceRequestDialog.txtRecordNumber' | translate : 'Record number'}}" [(ngModel)]="recordNumber">
            </mat-form-field>
          </div>
          <div class="col-12 mt-3">
            <span class="material-icons" style="font-size: 22px;">info</span><span style="margin-top: 3px; font-size: 12px; display: inline-block; vertical-align: top; margin-left: 5px;">
              {{ 'Turbo.Service.CreateServiceRequestDialog.RecordNumberInfo' | translate : 'The record number is obtained from a police report.' }}
            </span>
          </div>
        </div>
        <div class="errorMessage">
          <span *ngIf="errNoRecordNumber">{{ 'Turbo.Service.CreateServiceRequestDialog.errNoRecordNumber' | translate : 'Please enter a record number from the police report.' }}</span>
        </div>
      </t4-container>

      <t4-container title="{{ 'Turbo.Service.CreateServiceRequestDialog.lblDamageReportFromCustomerTemplate' | translate : 'Template for: Customer damage report' }}" *ngIf="settings.isInsuranceCase">
        <div class="row">
          <div class="col-12" style="text-align: center; margin-bottom: 20px;">
            {{ 'Turbo.Service.CreatedServiceRequestDialog.msgDocumentTemplate' | translate : 'To avoid paying double selfrisk you have to fill in and upload the damage report below.'}}
          </div>
          <div class="col-4" style="text-align: center">
            <button mat-button (click)="downloadTemplate('sv')">
              <img src="/images/Icons/filetypes/Pdf.png" style="height: 32px" /><br />
              {{ 'Turbo.Service.CreateServiceRequestDialog.lblSwedish' | translate : 'Swedish' }}
            </button>
          </div>
          <div class="col-4" style="text-align: center">
            <button mat-button (click)="downloadTemplate('nn')">
              <img src="/images/Icons/filetypes/Pdf.png" style="height: 32px" /><br />
              {{ 'Turbo.Service.CreateServiceRequestDialog.lblNorwegian' | translate : 'Norwegian' }}
            </button>
          </div>
          <div class="col-4" style="text-align: center">
            <button mat-button (click)="downloadTemplate('da')">
              <img src="/images/Icons/filetypes/Pdf.png" style="height: 32px" /><br />
              {{ 'Turbo.Service.CreateServiceRequestDialog.lblDanish' | translate : 'Danish' }}
            </button>
          </div>
        </div>
      </t4-container>

      <div *ngIf="isBackOffice" style="border: 1px solid #ccc; background-color: white; margin-top:20px; width:fit-content; padding:10px 20px 10px 20px;">
        <mat-checkbox color="primary" [(ngModel)]="disableChecked">{{ 'Turbo.Service.CreatServiceRequestDialog.lblDisableTrailer' | translate : 'Disable Trailer'}}</mat-checkbox>
      </div>

      <div style="height: 20px"></div>
    </div>
  </div>

  <div class="loader" *ngIf="loading.dialog">
    <div class="message">{{ loadingMessageKey | translate : loadingMessageDefault }}</div>
    <mat-progress-bar mode="indeterminate" style="width: 100%; bottom: 0;"></mat-progress-bar>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <div class="col-8" style="text-align: left; padding-left: 5px; padding-right: 5px;">
    <button mat-flat-button style="margin: 3px;" (click)="uploadImages()" *ngIf="!isTrailerInspectionFlow && issueTypeSelected">
      <mat-icon *ngIf="imageUploaded">check</mat-icon>
      {{ 'Turbo.Service.CreateServiceRequestDialog.AddImages' | translate : 'Add images' }}
    </button>
    <button mat-flat-button style="margin: 3px;" (click)="uploadFiles()" *ngIf="!isTrailerInspectionFlow && issueTypeSelected">
      <mat-icon *ngIf="fileUploaded">check</mat-icon>
      {{ 'Turbo.Service.CreateServiceRequestDialog.AddDamageReport' | translate : 'Add damage report' }}
    </button>
    <button mat-flat-button style="margin: 3px;" (click)="redirectToInsuranceHelp()" *ngIf="!isTrailerInspectionFlow">
      <mat-icon>help</mat-icon>
      {{ 'Turbo.Service.CreateServiceRequestDialog.Help' | translate:'Help'}}
    </button>
  </div>
  <div class="col-4" style="text-align: right; padding-left: 5px; padding-right: 5px;">

    <button mat-flat-button color="primary" style="margin: 3px;" (click)="save()" *ngIf="issueTypeSelected">{{ 'Turbo.Service.CreateServiceRequestDialog.Save' | translate : 'Save' }}</button>
  </div>
</mat-dialog-actions>
<!--<div class="row">
    <mat-form-field style="width: 100%;">
        <input matInput [formControl]="txtKeywords" placeholder="{{'Turbo.OneWayAdmin.FindIssueDialog.txtKeywords' | translate : 'Enter request no or rental object'
                }}" />
                </mat-form-field>
                <div *ngIf="!requests">{{'Turbo.OneWayAdmin.FindIssueDialog.msgNoRequest' | translate : 'No service requests has been found'}}</div>
                <div *ngIf="requests" class="container-fluid" style="max-height: 250px; overflow: auto;">
                    <div *ngFor="let item of requests" class="row">
                        <div class="col-xs-12 list-item" matTooltip="{{ item.Description }}" (click)="selectedRequest = item" [ngClass]="{ 'selected': selectedRequest == item }">
                            <div class="statusIcon" style="float: left; margin: 12px;" [ngClass]="{'status-green': (item.Status == 50 || item.Status == 100), 'status-red': (!item.ExpectedResolveDate || item.ExpectedResolveDate < today), 'status-yellow': (item.ExpectedResolveDate < tomorrow && item.ExpectedResolveDate >= today) }"></div>
                            <span style="float: right">{{ 'Turbo.OneWayAdmin.Service.ServiceStatus_' + item.Status | translate }}</span>
                            {{ item.RequestNo }}<br />
                            {{ item.CreatedAt | date : 'yyyy-MM-dd HH:mm' }}
                        </div>
                    </div>
                </div>
                <div style="text-align: center">
                    <button class="btn btn-default" style="margin: 2px;" color="primary" [disabled]="!selectedRequest" (click)="confirm()">{{'Turbo.OneWayAdmin.FindIssueDialog.cmdSelect' | translate : 'Select'}}</button>
                </div>
            </div>-->
